/* Beanlab – Bean Club Abo-Auswahl inkl. Preisanzeige */
(function () {
  function init(root) {
    if (root.dataset.blReady) return;
    root.dataset.blReady = '1';
    var sectionId = root.dataset.section;
    var input = root.querySelector('[data-bl-input]');
    var panel = root.querySelector('[data-bl-panel]');
    var modes = root.querySelectorAll('[data-bl-mode]');
    var plans = root.querySelectorAll('[data-bl-plan]');
    var club = root.querySelector('[data-bl-mode="club"]');
    var prices = {};
    try { prices = JSON.parse(root.querySelector('[data-bl-abo-prices]').textContent); } catch (e) {}
    var form = document.getElementById('product-form-' + sectionId);
    var priceBox = document.getElementById('price-' + sectionId);
    var writing = false;

    function currentVariantId() {
      var idInput = form && form.querySelector('[name="id"]');
      return idInput ? String(idInput.value) : null;
    }

    function renderPrice() {
      if (!priceBox) return;
      var old = priceBox.querySelector('[data-bl-abo-price]');
      var planId = input.value;
      var v = prices[currentVariantId()];
      writing = true;
      if (old) old.remove();
      priceBox.classList.remove('bl-abo-price-active');
      var plan = v && v.plans ? v.plans[planId] : null;
      if (planId && plan) {
        var now = typeof plan === 'string' ? plan : plan.p;
        var unit = typeof plan === 'string' ? '' : plan.u;
        var wrap = document.createElement('div');
        wrap.className = 'bl-abo-price';
        wrap.setAttribute('data-bl-abo-price', '');
        wrap.innerHTML = '<span class="bl-abo-price__now">' + now + '</span>' +
          (now !== v.regular ? '<s class="bl-abo-price__old">' + v.regular + '</s>' : '') +
          '<span class="bl-abo-price__tag">im Bean Club</span>' +
          (unit ? '<span class="bl-abo-price__unit">' + unit + '</span>' : '');
        priceBox.appendChild(wrap);
        priceBox.classList.add('bl-abo-price-active');
      }
      setTimeout(function () { writing = false; }, 0);
    }

    function selectPlan(btn) {
      plans.forEach(function (p) {
        var on = p === btn;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      input.value = btn ? btn.dataset.blPlan : '';
      renderPrice();
    }

    function setMode(mode) {
      modes.forEach(function (m) {
        var on = m.dataset.blMode === mode;
        m.classList.toggle('is-active', on);
        m.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var isClub = mode === 'club';
      panel.hidden = !isClub;
      club.setAttribute('aria-expanded', isClub ? 'true' : 'false');
      if (isClub) {
        selectPlan(root.querySelector('[data-bl-plan].is-active') || plans[0]);
      } else {
        input.value = '';
        renderPrice();
      }
    }

    modes.forEach(function (m) { m.addEventListener('click', function () { setMode(m.dataset.blMode); }); });
    plans.forEach(function (p) { p.addEventListener('click', function () { selectPlan(p); }); });

    /* Dawn ersetzt den Preis bei Variantenwechsel – danach Abo-Preis neu setzen */
    if (priceBox && window.MutationObserver) {
      new MutationObserver(function () { if (!writing) renderPrice(); })
        .observe(priceBox, { childList: true, subtree: true });
    }
    if (form) form.addEventListener('change', function () { setTimeout(renderPrice, 50); });

    setMode('once');
  }

  function boot() { document.querySelectorAll('[data-bl-abo]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
